module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ls-table-wrapper"
  }, [_c('div', {
    ref: "tableInner",
    staticClass: "ls-table-inner"
  }, [_c('table', {
    staticClass: "ls-table"
  }, [_c('thead', [_c('tr', _vm._l((_vm.tableLayout.header), function(h) {
    return _c('th', [_c('div', {
      staticClass: "cell-inner"
    }, [_vm._v(_vm._s(h.label))])])
  }), 0)]), _vm._v(" "), (_vm.tableData.length) ? _c('tbody', _vm._l((_vm.tableDataSlice), function(r) {
    return _c('tr', _vm._l((_vm.tableLayout.header), function(h) {
      return _c('td', [_c('div', {
        staticClass: "cell-inner"
      }, [_vm._v(_vm._s(r[h.key]))])])
    }), 0)
  }), 0) : _c('tbody', [_c('tr', [_c('td', {
    staticClass: "row-no-data",
    attrs: {
      "colspan": _vm.tableLayout.header.length
    }
  }, [_vm._v("No data available")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ls-table-pagination"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.currentPage == 0
    },
    on: {
      "click": function($event) {
        _vm.currentPage--
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" prev")]), _vm._v(" | \n    "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.currentPage >= _vm.lastPage
    },
    on: {
      "click": function($event) {
        _vm.currentPage++
      }
    }
  }, [_vm._v("next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), (_vm.lastPage >= 0) ? _c('span', [_vm._v("page " + _vm._s(_vm.currentPage + 1) + " of " + _vm._s(_vm.lastPage + 1) + "   "), _c('small', [_vm._v("(" + _vm._s(_vm.tableData.length) + " records)")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f2f78b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/LsStatsTable.vue
// module id = 653
// module chunks = 0